import _ from 'underscore';
import {
  ActionVerbs,
  ActionStages,
  ActionSlices,
  splitActionName,
} from '../common/action-utilities';

export const initialPreferenceState = {
  isLoading: false,
  lastUpdate: null,
  value: undefined,
  error: null,
};

function handleSet(state, params, stage) {
  const { newValue } = params;

  switch (stage) {
    case ActionStages.start: {
      return {
        ...state,
        value: newValue,
        isLoading: true,
      };
    }
    case ActionStages.complete:
      return {
        ...state,
        value: newValue,
        isLoading: false,
        lastUpdate: Date.now(),
      };
    default:
      return state;
  }
}

function handleGet(state, params, stage) {
  switch (stage) {
    case ActionStages.complete: {
      const { newValue } = params;

      // NOTE: null is allowed as a newValue
      const value = _.isUndefined(newValue) ? state.value : newValue;

      return {
        ...state,
        value,
        isLoading: false,
        lastUpdate: Date.now(),
      };
    }
    case ActionStages.fail: {
      const { error } = params;
      return {
        ...state,
        isLoading: false,
        error,
      };
    }
    default:
      return state;
  }
}

export function preferenceReducerCreator(preferenceName) {
  return (state = initialPreferenceState, action) => {
    const { params = {} } = action;
    const {
      slice,
      label,
      verb,
      stage,
    } = splitActionName(action);

    if (slice !== ActionSlices.preference) {
      return state;
    }

    if (label && label !== preferenceName) {
      return state;
    }

    switch (verb) {
      case ActionVerbs.set:
        return handleSet(state, params, stage);
      case ActionVerbs.get:
        return handleGet(state, params, stage);
      default:
        return state;
    }
  };
}
